module.exports = __webpack_public_path__ + "img/a9c85f4042de286e106d8ec949a070c.3ea6c6ce.png";